import React from "react";
import { default as WCircularProgress } from "@mui/material/CircularProgress";

function CircularProgress(props) {
  return <WCircularProgress {...props} />;
}

export default CircularProgress;
